import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=39db9361&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "../assets/scss/sidebar.scss?vue&type=style&index=0&id=39db9361&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db9361",
  null
  
)

export default component.exports